import { getUid } from "../../auth/AuthManager";
import OnevocaServerError from "../../common/OnevocaServerError";
import getApiInstance from "../../common/api";
import { setCachedLanguageCodeToIndexedDB } from "../../settings/util/voiceSettings";

export async function detactLanguageCode(text: string): Promise<string> {
  try {
    const uid = await getUid();

    const parameters: { [key: string]: any } = {};
    parameters["uid"] = uid;
    parameters["text"] = text;

    const response = await getApiInstance(undefined).post(
      "/word/detectLanguage.php",
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const result = response.data.result;
    if (result === undefined) {
      return Promise.reject(new Error("No data."));
    }

    const code = result as string;
    setCachedLanguageCodeToIndexedDB(text, code);
    return code;
  } catch (error) {
    return Promise.reject(error);
  }
}
